var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "information",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a6a6a6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    className: "cls-1",
    cx: 1.172,
    cy: 1.172,
    r: 1.172,
    transform: "translate(10.828 16.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    className: "cls-1",
    d: "M12,0A12,12,0,1,0,24,12,11.993,11.993,0,0,0,12,0Zm0,22.125A10.125,10.125,0,1,1,22.125,12,10.12,10.12,0,0,1,12,22.125Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    className: "cls-1",
    d: "M179.75,128.5a3.754,3.754,0,0,0-3.75,3.75.938.938,0,0,0,1.875,0,1.875,1.875,0,1,1,1.875,1.875.937.937,0,0,0-.937.938v2.344a.938.938,0,0,0,1.875,0v-1.525a3.75,3.75,0,0,0-.937-7.381Z",
    transform: "translate(-167.75 -122.477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/Information.b5faec4d.svg";
export { ForwardRef as ReactComponent };